import httpClient from "./httpClient";

const attributeValueCreate = (lang, data) =>
  httpClient.post(`/attributeValue/${lang}`, data);

const attributeValueUpdate = (id, lang, data) =>
  httpClient.put(`/attributeValue/${id}/${lang}`, data);

const attributeValueDelete = id => httpClient.delete(`/attributeValue/${id}`);

export { attributeValueCreate, attributeValueUpdate, attributeValueDelete };
